
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 2118 1921.8"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"escena_x5F_path"}},[_c('path',{attrs:{"id":"escenario_x5F_2_x5F_path","d":"M2118 610.9L1059 .3 0 611.7l.1 698.7 1059 611.4L2118 1310.3V610.9z","opacity":".15","fill":"#fff"}}),_c('path',{staticClass:"st1 activity",attrs:{"id":"act_06","fill":"rgba(10,10,10,0.2)","d":"M1054.9 600.1h273.8v339.6h-273.8z"}}),_c('path',{staticClass:"st1 activity",attrs:{"id":"act_07","fill":"rgba(10,10,10,0.2)","d":"M780 946.8h322.2v255.1H780z"}}),_c('path',{staticClass:"st1 activity",attrs:{"id":"act_08","fill":"rgba(10,10,10,0.2)","d":"M1352.2 553.2h323.7v309.2h-323.7z"}})])])
          )
        }
      }
    